"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createUniqueElementIds = require("../../../utils/createUniqueElementIds/createUniqueElementIds");

var _useActiveElement = _interopRequireDefault(require("../../../utils/useActiveElement"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

var _Radio = _interopRequireDefault(require("../../Radio"));

var _DescriptionMessages = _interopRequireDefault(require("../DescriptionMessages"));

var _InputField = _interopRequireDefault(require("../InputField"));

var _excluded = ["ariaLabelledBy", "children", "description", "descriptionId", "descriptionUniqueId", "errorMessages", "fieldsetStyles", "formControlStyles", "groupFormControlId", "isDescriptionHtml", "isDisabled", "isHorizontal", "isOptional", "isRadioGroup", "isValid", "legendLabel"],
    _excluded2 = ["ariaLabelledBy", "classes", "description", "descriptionId", "errorMessages", "isCheckboxGroup", "isDescriptionHtml", "isDisabled", "isHorizontal", "isOptional", "isRadioGroup", "isValid", "groupFormControlId", "groupedItems", "legendLabel", "name"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GroupContainer = function GroupContainer(_ref) {
  var ariaLabelledBy = _ref.ariaLabelledBy,
      children = _ref.children,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      descriptionUniqueId = _ref.descriptionUniqueId,
      errorMessages = _ref.errorMessages,
      fieldsetStyles = _ref.fieldsetStyles,
      formControlStyles = _ref.formControlStyles,
      groupFormControlId = _ref.groupFormControlId,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isHorizontal = _ref.isHorizontal,
      isOptional = _ref.isOptional,
      isRadioGroup = _ref.isRadioGroup,
      isValid = _ref.isValid,
      legendLabel = _ref.legendLabel,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var groupContainerRef = (0, _react.useRef)(null);
  var groupLegendRef = (0, _react.useRef)(null);
  var focusedElement = (0, _useActiveElement.default)(); // When the input group's state is invalid, send focus to the legend

  (0, _react.useEffect)(function () {
    if (!isValid) {
      groupLegendRef.current.focus();
    }
  }, [isValid]);
  var inputsWrapperStyles = (0, _classnames.default)('form-control__inputs-wrapper', {
    'form-control__inputs-wrapper--horizontal': isHorizontal
  }); // When focus is sent to the input group container by the Error Summary component, automatically set focus to the legend

  (0, _react.useEffect)(function () {
    if (!isValid && focusedElement.id === groupFormControlId) {
      groupLegendRef.current.focus();
    }
  }, [focusedElement]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: formControlStyles,
    id: groupFormControlId,
    "data-testid": groupFormControlId,
    tabIndex: "-1",
    ref: groupContainerRef
  }, additionalProps), /*#__PURE__*/_react.default.createElement("fieldset", {
    className: fieldsetStyles
  }, /*#__PURE__*/_react.default.createElement("legend", {
    className: "form-control__legend",
    "aria-describedby": description && (descriptionId || descriptionUniqueId) || null,
    "aria-labelledby": ariaLabelledBy ? "".concat(ariaLabelledBy, " legendLabelId") : null,
    "data-testid": "legend-test-id",
    tabIndex: -1,
    ref: groupLegendRef
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "form-control__legend-wrapper",
    id: "legendLabelId"
  }, legendLabel, ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, description || !isValid && errorMessages), isOptional && /*#__PURE__*/_react.default.createElement("span", {
    className: "form-control__optional"
  }, "Optional"))), /*#__PURE__*/_react.default.createElement("div", {
    className: inputsWrapperStyles
  }, children)), (description || errorMessages && !isValid) && /*#__PURE__*/_react.default.createElement(_DescriptionMessages.default, {
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    description: description,
    isDescriptionHtml: isDescriptionHtml,
    errorMessages: errorMessages,
    isDisabled: isDisabled,
    isValid: isValid,
    isRadioGroup: isRadioGroup
  }));
};

function GroupedItems(_ref2) {
  var groupedItems = _ref2.groupedItems,
      isCheckboxGroup = _ref2.isCheckboxGroup,
      isDisabled = _ref2.isDisabled,
      isRadioGroup = _ref2.isRadioGroup,
      isValid = _ref2.isValid,
      name = _ref2.name;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, groupedItems.map(function (groupedItem) {
    var labelUniqueId = (0, _createUniqueElementIds.createUniqueElementIds)('label');
    var inputUniqueId = (0, _createUniqueElementIds.createUniqueElementIds)('input');
    var descriptionUniqueId = (0, _createUniqueElementIds.createUniqueElementIds)('description');
    var labelId = groupedItem.labelId || labelUniqueId;
    var inputId = groupedItem.inputId || inputUniqueId;
    var descriptionId = groupedItem.descriptionId || descriptionUniqueId;

    if (isRadioGroup) {
      return /*#__PURE__*/_react.default.createElement(_Radio.default, _extends({
        key: groupedItem.label,
        labelId: labelId,
        inputId: inputId,
        descriptionId: descriptionId,
        isDisabled: isDisabled,
        isGrouped: true,
        isValid: isValid,
        name: name
      }, groupedItem));
    }

    if (isCheckboxGroup) {
      return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
        key: groupedItem.label,
        labelId: labelId,
        inputId: inputId,
        descriptionId: descriptionId,
        isDisabled: isDisabled,
        isGrouped: true,
        isValid: isValid
      }, groupedItem));
    }

    return /*#__PURE__*/_react.default.createElement(_InputField.default, _extends({
      type: "text",
      key: groupedItem.label,
      labelId: labelId,
      inputId: inputId,
      descriptionId: descriptionId,
      isValid: isValid
    }, groupedItem));
  }));
}

var InputGroup = function InputGroup(_ref3) {
  var ariaLabelledBy = _ref3.ariaLabelledBy,
      classes = _ref3.classes,
      description = _ref3.description,
      descriptionId = _ref3.descriptionId,
      errorMessages = _ref3.errorMessages,
      isCheckboxGroup = _ref3.isCheckboxGroup,
      isDescriptionHtml = _ref3.isDescriptionHtml,
      isDisabled = _ref3.isDisabled,
      isHorizontal = _ref3.isHorizontal,
      isOptional = _ref3.isOptional,
      isRadioGroup = _ref3.isRadioGroup,
      isValid = _ref3.isValid,
      groupFormControlId = _ref3.groupFormControlId,
      groupedItems = _ref3.groupedItems,
      legendLabel = _ref3.legendLabel,
      name = _ref3.name,
      additionalProps = _objectWithoutProperties(_ref3, _excluded2);

  var descriptionUniqueId = (0, _createUniqueElementIds.createUniqueElementIds)('description');
  var formControlStyles = (0, _classnames.default)('form-control__container', 'form-control__input-group', _defineProperty({
    'form-control__container--error': !isValid
  }, classes, classes));
  var fieldsetStyles = (0, _classnames.default)('form-control__fieldset', {
    'form-control__fieldset--error': !isValid
  });
  return /*#__PURE__*/_react.default.createElement(GroupContainer, _extends({
    ariaLabelledBy: ariaLabelledBy,
    description: description,
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    errorMessages: errorMessages,
    fieldsetStyles: fieldsetStyles,
    formControlStyles: formControlStyles,
    groupFormControlId: groupFormControlId,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isHorizontal: isHorizontal,
    isOptional: isOptional,
    isRadioGroup: isRadioGroup,
    isValid: isValid,
    legendLabel: legendLabel
  }, additionalProps), /*#__PURE__*/_react.default.createElement(GroupedItems, {
    groupedItems: groupedItems,
    isCheckboxGroup: isCheckboxGroup,
    isDisabled: isDisabled,
    isRadioGroup: isRadioGroup,
    isValid: isValid,
    name: name
  }));
};

GroupContainer.propTypes = {
  ariaLabelledBy: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),
  descriptionId: _propTypes.default.string,
  descriptionUniqueId: _propTypes.default.string,
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),
  fieldsetStyles: _propTypes.default.string.isRequired,
  formControlStyles: _propTypes.default.string.isRequired,
  groupFormControlId: _propTypes.default.string,
  isDescriptionHtml: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool,
  isHorizontal: _propTypes.default.bool,
  isOptional: _propTypes.default.bool,
  isRadioGroup: _propTypes.default.bool,
  isValid: _propTypes.default.bool,
  legendLabel: _propTypes.default.string.isRequired
};
GroupContainer.defaultProps = {
  ariaLabelledBy: null,
  description: '',
  descriptionId: '',
  descriptionUniqueId: '',
  errorMessages: [],
  groupFormControlId: '',
  isDescriptionHtml: false,
  isDisabled: false,
  isHorizontal: false,
  isOptional: false,
  isRadioGroup: false,
  isValid: true
};
GroupedItems.propTypes = {
  groupedItems: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  isCheckboxGroup: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool,
  isRadioGroup: _propTypes.default.bool,
  isValid: _propTypes.default.bool,
  name: _propTypes.default.string
};
GroupedItems.defaultProps = {
  isCheckboxGroup: false,
  isDisabled: false,
  isRadioGroup: false,
  isValid: false,
  name: null
};
InputGroup.propTypes = {
  /**
   Optional. Adds `aria-labelledby` attribute to associate the input with a page level error message.
   */
  ariaLabelledBy: _propTypes.default.string,

  /**
   Optional. Custom group container styles.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Custom description of input group. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. Custom ID for description of input group.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. Used to render logic specific to the Checkbox Group.
   */
  isCheckboxGroup: _propTypes.default.bool,

  /**
   Optional. Used to pass HTML in the description prop. Defaults false.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Defaults false.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Displays the input group options horizontally. Defaults to `false`.
   */
  isHorizontal: _propTypes.default.bool,

  /**
   Optional. Should not be used if `isRequired` is used. Adds "Optional" text to the top right of the input. Defaults false.
   */
  isOptional: _propTypes.default.bool,

  /**
   Optional. Used to render logic specific to the Radio Group.
   */
  isRadioGroup: _propTypes.default.bool,

  /**
   Optional. Defaults true.
   */
  isValid: _propTypes.default.bool,

  /**
   Required. Custom ID for group container. Needed to ensure proper keyboard functionality.
   */
  groupFormControlId: _propTypes.default.string.isRequired,

  /**
   Required. The list of Grouped Items, objects with props from component that gets mapped over.
   */
  groupedItems: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,

  /**
   Required. Legend text or description need to be used to properly group the fields.
   */
  legendLabel: _propTypes.default.string.isRequired,

  /**
   Required for RadioGroup only. The common name attribute for each input in the group.
   */
  name: _propTypes.default.string
};
InputGroup.defaultProps = {
  ariaLabelledBy: null,
  classes: '',
  description: '',
  descriptionId: '',
  errorMessages: [],
  isCheckboxGroup: false,
  isDescriptionHtml: false,
  isDisabled: false,
  isHorizontal: false,
  isOptional: false,
  isRadioGroup: false,
  isValid: true,
  name: null
};
var _default = InputGroup;
exports.default = _default;